module.exports = __webpack_public_path__ + "img/shopify_instruction_6.b3414b8f.png";